import { axios } from "../../../config";

export const getUploads = (queryVars) => {
  return axios.post("get-uploads", queryVars);
};
